"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyStakeAddressSchema = exports.ASIC_ADDRESS_CHARACTERS = exports.AUSTRALIAN_POSTCODE_LIMIT_MESSAGE = exports.POSTCODE_REQUIRED = exports.COUNTRY_REQUIRED = exports.STATE_REQUIRED = exports.LOCALITY_REQUIRED = exports.STREET_REQUIRED = void 0;
const yup = __importStar(require("yup"));
exports.STREET_REQUIRED = "Please enter Street Number and Name";
exports.LOCALITY_REQUIRED = "Please enter City, Town or Suburb";
exports.STATE_REQUIRED = "Please enter State";
exports.COUNTRY_REQUIRED = "Please enter Country";
exports.POSTCODE_REQUIRED = "Please enter Post code";
exports.AUSTRALIAN_POSTCODE_LIMIT_MESSAGE = "Postcode should be exactly 4 digits long";
// eslint-disable-next-line no-useless-escape
exports.ASIC_ADDRESS_CHARACTERS = /^[a-zA-Z!"#$%&'’(), *+-.\/:<=>?@ \d]+$/;
exports.MyStakeAddressSchema = {
    careOf: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .matches(exports.ASIC_ADDRESS_CHARACTERS)
        .max(50)
        .label("Care of"),
    line2: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .matches(exports.ASIC_ADDRESS_CHARACTERS)
        .max(50)
        .label("Unit number"),
    street: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .required(exports.STREET_REQUIRED)
        .matches(exports.ASIC_ADDRESS_CHARACTERS)
        .max(52)
        .label("Street name and number"),
    locality: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .required(exports.LOCALITY_REQUIRED)
        .matches(exports.ASIC_ADDRESS_CHARACTERS)
        .min(2)
        .max(30)
        .label("Suburb"),
    state: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .when("country", (country, schema) => country && (country.toLowerCase() === "australia" || country.toLowerCase() === "au")
        ? schema
            .required(exports.STATE_REQUIRED)
            .min(2)
            .matches(/^[A-Z]+$/)
            .max(3)
        : schema.notRequired().max(100))
        .label("State"),
    postcode: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .when("country", (country, schema) => country && (country.toLowerCase() === "australia" || country.toLowerCase() === "au")
        ? schema
            .required(exports.POSTCODE_REQUIRED)
            .matches(/^\d+$/)
            .min(4, exports.AUSTRALIAN_POSTCODE_LIMIT_MESSAGE)
            .max(4, exports.AUSTRALIAN_POSTCODE_LIMIT_MESSAGE)
        : schema
            .matches(/^[a-zA-Z\d]+$/)
            .min(1)
            .max(10))
        .label("Postcode"),
    country: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .required(exports.COUNTRY_REQUIRED)
        .matches(exports.ASIC_ADDRESS_CHARACTERS)
        .min(1)
        .max(30)
        .label("Country"),
};
//# sourceMappingURL=MyStakeAddress.js.map